<sk-modal-content [title]="'label.FilterSettings' | translate"
                  [cancelBtnText]="'label.Close'"
                  (closed)="closeWithoutResult()">

  <ng-container id="sk-modal-body">
    <form [formGroup]="userFilterForm">
      <div class="flex-row flex-middle">
        <sk-text
          data-test="module-filter-title-input"
          [label]="'label.Title' | translate"
          [formControlName]="'name'"
          [required]="true">
        </sk-text>
        <sk-button size="m"
                   appearance="icon"
                   class="ms-2"
                   data-test="module-filter-translations-button"
                   translateManager
                   [languages]="languages$ | async"
                   [(translations)]="translationsName">
          <ng-template buttonPrefix>
            <i class="icon fas fa-fw fa-globe"></i>
          </ng-template>
        </sk-button>
      </div>

      <sk-checkbox
        data-test="module-filter-isPublic-checkbox"
        [label]="'label.IsPublic' | translate"
        [formControlName]="'isPublic'">
      </sk-checkbox>

      @if (userFilterForm.get('isPublic').value) {
        <sk-checkbox
          data-test="module-filter-isPinnedDefault-checkbox"
          [label]="'label.IsPinnedByDefault' | translate"
          [formControlName]="'isPinnedByDefault'">
        </sk-checkbox>
      }
    </form>
  </ng-container>

  <ng-container id="sk-modal-footer-buttons">
    <sk-button
      [color]="'primary'"
      [label]="'label.Save' | translate"
      data-test="modal-footer-confirm-button"
      [disabled]="userFilterForm.invalid"
      (click)="onFilterSave()">
      <ng-template buttonPrefix>
        <i class="fas fa-check"></i>
      </ng-template>
    </sk-button>
  </ng-container>
</sk-modal-content>
